import type { Certification } from '@applicator/shared'

export type CertificationFieldFlag =
  | 'nameIncluded'
  | 'issuerIncluded'
  | 'datesIncluded'
  | 'credentialUrlIncluded'

export function cascadeCertificationIncluded(
  cert: Certification,
  included: boolean
): Certification {
  return {
    ...cert,
    included,
    nameIncluded: included,
    issuerIncluded: included,
    datesIncluded: included,
    credentialUrlIncluded: included,
  }
}

/** Parent off → all nested inclusion flags off (fixes legacy/sync drift). */
export function normalizeCertificationInclusion(cert: Certification): Certification {
  if (cert.included) return cert
  return cascadeCertificationIncluded(cert, false)
}

export function normalizeCertificationsList(certs: Certification[]): Certification[] {
  return certs.map(normalizeCertificationInclusion)
}

export function toggleCertificationField(
  cert: Certification,
  field: CertificationFieldFlag
): Certification {
  if (!cert.included) return cert
  const next = !(cert[field] ?? true)
  const updated = { ...cert, [field]: next }
  if (next) {
    return { ...updated, included: true }
  }
  return updated
}

/** Nested checkbox state in editor (parent must be on). */
export function isCertificationNestedFieldIncluded(
  cert: Certification,
  field: CertificationFieldFlag
): boolean {
  return cert.included && (cert[field] ?? true)
}

export function defaultNewCertification(id: string): Certification {
  return {
    id,
    name: '',
    issuer: '',
    startDate: '',
    endDate: '',
    credentialUrl: '',
    included: false,
    nameIncluded: true,
    issuerIncluded: true,
    datesIncluded: true,
    credentialUrlIncluded: true,
  }
}
